import * as urls from 'mk2/apps/bazaar/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'bazaar',
    exact: true,
    path: urls.bazaarSellerSearch,
    getPage: () => {
        return import('mk2/apps/bazaar/containers/SellerSearch/SellerSearchPage' /* webpackChunkName: "bazaar.SellerSearch" */);
    },
    modules: [ 'mk2/apps/bazaar/containers/SellerSearch/SellerSearchPage' ],
}];
